<template>
	<div :class="{ loading: isLoading, results: variables.results }">
		<div id="progress-bar">
			<span :style="{ width: progress }"></span>
		</div>
		<div id="quiz-header" :class="{ hidden: variables.currentStep == 0 }">
			<div class="container">
				<button id="back-button" @click="previousStep">{{ backButtonText }}</button>
				<figure id="logo"><a href="/"><img alt="Metro Vein Centers Logo" class="not-lazy" height="23" src="/assets/images/logo.svg" width="250"></a></figure>
				<div id="page-progress">{{ displayStep }} {{ isSpanish ? 'de' : 'of' }} {{ displayTotal }}</div>
				<ul class="language-switcher notranslate">
					<li><a href="/quiz" hreflang="en" :class="{current: !isSpanish}">en</a></li>
					<li><a href="/es/quiz" hreflang="es" :class="{current: isSpanish}">es</a></li>
				</ul>
			</div>
		</div>
		<main tabindex="-1">
			<transition-group :name="transitionForward ? 'slide' : 'slideback'">
				<section v-for="(panel, index) in panels" :key="panel.id" :id="panel.id" v-show="index == variables.currentStep">
					<quiz-panel
						:panel="panel"
						:variables="variables"
						:hubspot="hubspot"
						@next-step="nextStep"
						@skip-step="skipStep"
						@set-variable="setVariable"
						@submit-form="submitForm"
					></quiz-panel>
				</section>
			</transition-group>
		</main>
		<div class="quiz-error" :class="{show: showError}" v-html="errorMessage"></div>
		<loading-animation :load-screen-text="loadScreenText" />
	</div>
</template>

<script>
import QuizPanel from './QuizPanel';
import LoadingAnimation from './LoadingAnimation';
import gtag from './gtag.js';
export default {
	components: {
		QuizPanel,
		LoadingAnimation
	},

	mixins: [gtag],

	props: ['panels', 'microtime', 'backButtonText', 'loadScreenText', 'hubspot', 'resultsPage'],

	data() {
		return {
			transitionForward: true,
			errorMessage: '',
			showError: false,
			isLoading: false,
			isSpanish: document.documentElement.lang == 'es',
			variables: {
				currentStep: 0,
				symptoms: [],
				levels: {},
				goals: [],
				patientStoriesResult: 'A',
				didYouKnowResult: 'V1',
				results: false,
				skipLevels: false
			}
		}
	},

	beforeMount() {
		const urlParams = new URLSearchParams(window.location.search);
		const hasReset = urlParams.get('reset');
		if(hasReset !== null) {
			this.resetProgress();
		}
		const updateViewportHeight = () => {
			const panels = document.querySelectorAll('section[id^=panel]');
			panels.forEach(panel => {
				panel.style.setProperty('--viewport-height', `${window.innerHeight}px`);
			});
		};
		window.addEventListener('resize', updateViewportHeight);
		updateViewportHeight();
		// if(localStorage.getItem('quizData')) {
		// 	this.variables = Object.assign(this.variables, JSON.parse(localStorage.getItem('quizData')));
		// 	if(this.variables.results) {
		// 		this.sendToResultsPage();
		// 	}
		// }
	},
	mounted() {
		this.pageAnalytics();
	},
	methods: {
		pageAnalytics() {
			var tracking = getTrackingParameters();

			analytics.page(tracking, { anonymousId: Cookie.get('segment_anonymousId') });
		},

		previousStep() {
			if (this.currentPanel.name === 'did-you-know' && this.variables.skipLevels) {
				this.transitionForward = false;
				this.variables.skipLevels = false;
				this.variables.currentStep -= 2;
			} 
			else if (this.variables.currentStep > 0) {
				this.transitionForward = false;
				this.variables.currentStep--;
			}
		
			this.gtag({'event': 'Quiz', 'quiz-step': this.variables.currentStep});
		},

		hubspotFormSubmit() {
			this.isLoading = true;

			this.gtag({'event': 'QuizSubmission'});

			setTimeout(() => {
				this.sendToResultsPage();
			}, 2000);
		},

		nextStep() {
			if (this.currentPanel.name === 'symptoms') {
				// If "None of the above" was chosen
				this.variables.skipLevels = this.variables.symptoms.length === 0;
			}
		
			if (this.variables.currentStep < this.panels.length - 1) {
				this.transitionForward = true;
				this.variables.currentStep++;
			}
		
			// Add HubSpot Form
			if(this.currentPanel.name == 'form' && this.hubspot.formId && this.hubspot.portalId && window.hbspt) {
				var quizApp = this;
			
				window.hbspt.forms.create({
					region: 'na1',
					portalId: this.hubspot.portalId,
					formId: this.hubspot.formId,
					target: '.hbspt-form',
					onFormReady: function(f) {
						setHubspotCookies();
					},
					onFormSubmit: function() {
						quizApp.hubspotFormSubmit();
					}
				});
			}
		
			this.gtag({'event': 'Quiz', 'quiz-step': this.variables.currentStep});
		},

		skipStep() {
			if (this.variables.currentStep + 1 < this.panels.length - 1) {
				this.transitionForward = true;
				this.variables.skipLevels = true;
				this.variables.currentStep += 2;
			}
		},

		setVariable({key, value}) {
			this.variables[key] = value;
		},

		submitForm({first_name, last_name, email, phone, newsletterSignup}) {
			this.isLoading = true;

			if(phone) {
				phone = '1'+phone.replace(/-/g, '').replace(/\(|\)/g,'').replace(/\s/g, '');
			}

			const formData = this.zapierData(first_name, last_name, email, phone, newsletterSignup);

			// Send request to server with variables, data may need 💆‍♂️ on backend or frontend for Zapier
			axios.post('/process-quiz', formData).then(response => {
				if(response.data.notSpam) {
					// Exclude _time from Segment Tracking
					delete formData['_time'];

					// Add Segment Parameters
					formData['is_spam'] = false; // Value is always false since tracking is only sent if not spam
					formData['action_source'] = 'website';

					segmentTracking('quiz_submitted', formData);

					var dataLayerObj = {'event': 'QuizSubmission'};

					this.gtag({...dataLayerObj, ...formData});
				}

				setTimeout(() => {
					this.sendToResultsPage();
				}, 2000);
			}).catch(error => {
				this.errorMessage = error.response.data.message;
				this.showError = true;
				this.isLoading = false;
				setTimeout(() => {
					this.showError = false;
				}, 10000);
			})
		},

		saveData() {
			Cookie.set('quiz_result_did_you_know', this.variables.didYouKnowResult);
			Cookie.set('quiz_result_patient_stories', this.variables.patientStoriesResult);
			Cookie.set('quiz_result_final', this.finalResult());
			Cookie.set('quiz_symptom_varicose_veins', this.symptomToZapier('A'));
			Cookie.set('quiz_symptom_spider_veins', this.symptomToZapier('B'));
			Cookie.set('quiz_symptom_cramping_legs', this.symptomToZapier('C'));
			Cookie.set('quiz_symptom_restless_legs', this.symptomToZapier('D'));
			Cookie.set('quiz_symptom_ulcers', this.symptomToZapier('E'));
			Cookie.set('quiz_symptom_tingling_or_itching_legs', this.symptomToZapier('F'));
			Cookie.set('quiz_symptom_aching_legs', this.symptomToZapier('G'));
			Cookie.set('quiz_symptom_thickened_or_discolored_skin', this.symptomToZapier('H'));
			Cookie.set('quiz_symptom_pain_when_standing', this.symptomToZapier('I'));
			Cookie.set('quiz_symptom_leg_swelling', this.symptomToZapier('J'));
			Cookie.set('quiz_important_feel_better_physically', this.importantToZapier('a'));
			Cookie.set('quiz_important_feel_confident_about_how_my_legs_look', this.importantToZapier('b'));
			Cookie.set('quiz_important_rule_out_serious_health_issues', this.importantToZapier('c'));
			Cookie.set('quiz_important_be_proactive_about_my_vein_health', this.importantToZapier('d'));
			Cookie.set('quiz_important_learn_more_about_vein_health', this.importantToZapier('e'));
		},

		resetProgress() {
			Cookie.remove('quiz_result_did_you_know');
			Cookie.remove('quiz_result_patient_stories');
			Cookie.remove('quiz_result_final');
			Cookie.remove('quiz_symptom_varicose_veins');
			Cookie.remove('quiz_symptom_spider_veins');
			Cookie.remove('quiz_symptom_cramping_legs');
			Cookie.remove('quiz_symptom_restless_legs');
			Cookie.remove('quiz_symptom_ulcers');
			Cookie.remove('quiz_symptom_tingling_or_itching_legs');
			Cookie.remove('quiz_symptom_aching_legs');
			Cookie.remove('quiz_symptom_thickened_or_discolored_skin');
			Cookie.remove('quiz_symptom_pain_when_standing');
			Cookie.remove('quiz_symptom_leg_swelling');
			Cookie.remove('quiz_important_feel_better_physically');
			Cookie.remove('quiz_important_feel_confident_about_how_my_legs_look');
			Cookie.remove('quiz_important_rule_out_serious_health_issues');
			Cookie.remove('quiz_important_be_proactive_about_my_vein_health');
			Cookie.remove('quiz_important_learn_more_about_vein_health');
		},

		sendToResultsPage() {
			// Uncomment if the user's progress should be reset after completing the quiz.
			// this.resetProgress();
			this.variables.results = true;
			window.location = `/${this.resultsPage}?finalResult=${this.finalResult()}&patientStoriesResult=${this.variables.patientStoriesResult}`;
		},

		finalResult() {
			const symptoms = this.variables.levels;
			const symptomsLength = Object.keys(symptoms).length;
			// If symptoms were skipped
			if(symptomsLength === 0) {
				return 'R7';
			}
			// Only if Spider Veins NOR Skin Discoloration were chosen
			if (symptomsLength === 1) {
				if('B' in symptoms) {
					return 'R4';
				}
				if('H' in symptoms) {
					return 'R5';
				}
			}
			// If Spider Veins AND Skin Discoloration were chosen
			if(symptomsLength === 2) {
				if('B' in symptoms && 'H' in symptoms) {
					return 'R6';
				}
			}
			let severityCount = {};
			Object.values(symptoms).forEach(severity => {
				severityCount[severity] = (severityCount[severity] || 0) + 1;
			});
			// If all are evenly split
			if(severityCount.a / symptomsLength === severityCount.b / symptomsLength && severityCount.a / symptomsLength === severityCount.c / symptomsLength) {
				return 'R2';
			}
			// Follows the matrix for all other permutations.
			if(severityCount.a / symptomsLength >= .75) {
				return 'R1';
			}
			if(severityCount.b / symptomsLength >= .75) {
				return 'R2';
			}
			if(severityCount.c / symptomsLength >= .75) {
				return 'R3';
			}
			if(severityCount.a / symptomsLength >= .5) {
				return 'R2';
			}
			if(severityCount.b / symptomsLength >= .5) {
				return 'R2';
			}
			if(severityCount.c / symptomsLength >= .5) {
				return 'R3';
			}
			if(severityCount.a / symptomsLength >= .33) {
				return 'R2';
			}
			if(severityCount.b / symptomsLength >= .33) {
				return 'R2';
			}
			if(severityCount.c / symptomsLength >= .33) {
				return 'R2';
			}
			// If a calculation error is made, default to R7.
			console.log('Could not calculate result.')
			return 'R7';
		},

		zapierData(first_name, last_name, email, phone, newsletterSignup) {
			return {
				first_name,
				last_name,
				phone,
				email,
				nl_signup: newsletterSignup,
				quiz_name: 'Vein Health Quiz',
				did_you_know_result: this.variables.didYouKnowResult,
				patient_stories_result: this.variables.patientStoriesResult,
				final_result: this.finalResult(),
				symptom_varicose_veins: this.symptomToZapier('A'),
				symptom_spider_veins: this.symptomToZapier('B'),
				symptom_cramping_legs: this.symptomToZapier('C'),
				symptom_restless_legs: this.symptomToZapier('D'),
				symptom_ulcers: this.symptomToZapier('E'),
				symptom_tingling_or_itching_legs: this.symptomToZapier('F'),
				symptom_aching_legs: this.symptomToZapier('G'),
				symptom_thickened_or_discolored_skin: this.symptomToZapier('H'),
				symptom_pain_when_standing: this.symptomToZapier('I'),
				symptom_leg_swelling: this.symptomToZapier('J'),
				important_feel_better_physically: this.importantToZapier('a'),
				important_feel_confident_about_how_my_legs_look: this.importantToZapier('b'),
				important_rule_out_serious_health_issues: this.importantToZapier('c'),
				important_be_proactive_about_my_vein_health: this.importantToZapier('d'),
				important_learn_more_about_vein_health: this.importantToZapier('e'),
				'_time': this.microtime
			}
		},

		symptomToZapier(key) {
			if(key in this.variables.levels) {
				switch (this.variables.levels[key]) {
					case 'a':
						return 1;
					case 'b':
						return 2;
					case 'c':
						return 3;
					default:
						return 0;
				}
			}
			return 0;
		},

		importantToZapier(key) {
			return Object.values(this.variables.goals).indexOf(key) > -1 ? 1 : 0;
		}
	},

	computed: {
		progress() {
			return (this.variables.currentStep / (this.panels.length - 1)) * 100 + '%';
		},

		currentPanel() {
			return this.panels[this.variables.currentStep];
		},

		displayTotal() {
			return this.variables.skipLevels
				? this.panels.length - 2
				: this.panels.length - 1;
		},

		displayStep() {
			if (!this.variables.skipLevels) {
				return this.variables.currentStep;
			}
		
			return Math.max(this.variables.currentStep - 1, 1);
		}
	},

	watch: {
		variables: {
			handler() {
				this.saveData();
			},
			deep: true
		}
	}
}
</script>
